import { createSlice } from '@reduxjs/toolkit';

export const settingSlice = createSlice({
    name: 'settings',
    initialState: {
        view: 'week',
        blockScroll: false,
        switchWeek: false,
        switchYear: false,
        switchMonth: false,
        switchGraphYear: false,
        switchGraphMonth: false,
        switchViewYear: false,
        switchViewWeek: false,
        switchGraphWeek: false,
        showPicker: false,
        section: false,
        path: null,
        metodoAggiunto: null,
        overlayNotice: false,
        ricarica3612Effettuata: false,
    },
    reducers: {
        setView: (state, action) => {
            state.view = action.payload
        },
        setBlockScroll: (state, action) => {
            state.blockScroll = action.payload
        },
        setSwitchWeek: (state, action) => {
            state.switchWeek = action.payload
        },
        setSwitchYear: (state, action) => {
            state.switchYear = action.payload
        },
        setSwitchMonth: (state, action) => {
            state.switchMonth = action.payload
        },
        setSwitchGraphYear: (state, action) => {
            state.switchGraphYear = action.payload
        },
        setSwitchGraphMonth: (state, action) => {
            state.switchGraphMonth = action.payload
        },
        setSwitchGraphWeek: (state, action) => {
            state.switchGraphWeek = action.payload
        },
        setSwitchViewYear: (state, action) => {
            state.switchViewYear = action.payload
        },
        setSwitchViewWeek: (state, action) => {
            state.switchViewWeek = action.payload
        },
        setShowPicker: (state, action) => {
            state.showPicker = action.payload
        },
        setSection: (state,action) => {
            state.section = action.payload
        },
        setPath: (state, action) => {
            state.path = action.payload
        },
        setMetodoAggiunto: (state, action) => {
            state.metodoAggiunto = action.payload
        },
        setOverlayNotice: (state, action) => {
            state.overlayNotice = action.payload
        },
        setRicarica3612Effettuata: ( state, action ) => {
            state.ricarica3612Effettuata = action.payload
        }
    }
});
export const {setMetodoAggiunto, setRicarica3612Effettuata, setOverlayNotice, setPath, setSection, setShowPicker, setOfferta, setView, setSwitchWeek, setSwitchYear, setSwitchGraphYear, setSwitchGraphMonth,setSwitchMonth, setBlockScroll, setSwitchViewYear, setSwitchGraphWeek, setSwitchViewWeek} = settingSlice.actions;
export default settingSlice.reducer;